import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { createContact } from "../API/endpoint";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    sujet: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");
      await createContact(formData);
      setSuccess(true);
      setFormData({ nom: "", prenom: "", email: "", sujet: "", message: "" });
      setTimeout(() => setSuccess(false), 5000);
    } catch (err) {
      setError("Erreur lors de l'envoi du message. Veuillez réessayer.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="App-main">
      <Helmet>
        <title>Contact - Déco Ariège</title>
        <meta
          name="description"
          content="Contactez-nous pour vos questions sur nos produits en bois artisanal. Service client disponible pour commandes et informations en Ariège."
        />
      </Helmet>
      <h2 className="section-title">CONTACTEZ-MOI</h2>
      <section className="contact-section">
        <div className="contact-content">
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="nom"
                placeholder="Votre nom"
                value={formData.nom}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="prenom"
                placeholder="Votre prénom"
                value={formData.prenom}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Votre email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="sujet"
                placeholder="Sujet"
                value={formData.sujet}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Votre message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <button className="contact-submit-btn" type="submit" disabled={loading}>
                {loading ? "Envoi..." : "Envoyer"}
              </button>
              {success && (
                <p style={{ color: "green", marginTop: "10px" }}>
                  Message envoyé avec succès !
                </p>
              )}
              {error && (
                <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
              )}
            </form>
          </div>
          <div className="contact-info">
            <br />
            {/* <br /> */}
            <p
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                fontStyle: "italic",
              }}
            >
              Certains articles seront créer sur commande, n'hésitez pas à
              demander !
            </p>

            <p>
              <i className="bi bi-house"></i> Patricia Perrin, 4 Chemin de la
              Zone Artisanale, 09350 Daumazan-sur-Arize
            </p>
            <p>
              <i className="bi bi-telephone"></i> Téléphone:{" "}
              <a href="tel:+33-0614772471">+33-0614772471</a>
            </p>
            <p>
              <i className="bi bi-envelope"></i> Email:{" "}
              <a href="mailto:aicirtap_nirrep@live.fr">
                aicirtap_nirrep@live.fr
              </a>
            </p>
            <p>
              <i className="bi bi-clock"></i> Horaires: Lundi au Vendredi - de
              8h00 à 19h00
            </p>
          </div>
          <div className="contact-map">
            <iframe
              src="https://maps.google.com/maps?q=43.141619,1.293257&output=embed"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Carte de localisation"
            ></iframe>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
